export * from '@primeuix/themes/aura/galleria';
export { default } from '@primeuix/themes/aura/galleria';
